import { useCallback } from 'react';
import PropTypes from 'prop-types';

import { PROMPT_MENU_TYPE } from '../../lib';

import { MenuItemBank } from './components/MenuItemBank';
import { MenuItemImage } from './components/MenuItemImage';
import { MenuItemResource } from './components/MenuItemResource';
import { MenuItemUrl } from './components/MenuItemUrl';

const propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(Object.values(PROMPT_MENU_TYPE)).isRequired,
  item: PropTypes.shape().isRequired,
  onAction: PropTypes.func.isRequired,
  menuType: PropTypes.string,
  index: PropTypes.number,
  isApplicationModeInfinity: PropTypes.bool,
  quickSearchMode: PropTypes.bool,
  noTags: PropTypes.bool,
};

const defaultProps = {
  className: '',
  menuType: '',
  index: 0,
  isApplicationModeInfinity: false,
  quickSearchMode: false,
  noTags: false,
};

export const MenuItem = ({
  className,
  type,
  item,
  onAction,
  menuType,
  index,
  isApplicationModeInfinity,
  quickSearchMode,
  noTags,
}) => {
  const handleAction = useCallback(
    (action, data) => {
      const enrichedData = {
        ...data,
        widget: getWidget(menuType, quickSearchMode),
        menuType,
        index,
        noTags,
      };

      onAction(action, enrichedData);
    },
    [index, menuType, noTags, onAction, quickSearchMode]
  );

  switch (type) {
    case PROMPT_MENU_TYPE.image:
      return (
        <MenuItemImage
          className={className}
          item={item}
          onAction={handleAction}
        />
      );

    case PROMPT_MENU_TYPE.url:
      return (
        <MenuItemUrl
          className={className}
          item={item}
          onAction={handleAction}
        />
      );

    case PROMPT_MENU_TYPE.bank:
      return (
        <MenuItemBank
          className={className}
          item={item}
          onAction={handleAction}
          isApplicationModeInfinity={isApplicationModeInfinity}
        />
      );

    case PROMPT_MENU_TYPE.document:
    case PROMPT_MENU_TYPE.audio:
    case PROMPT_MENU_TYPE.video:
      return (
        <MenuItemResource
          className={className}
          item={item}
          onAction={handleAction}
        />
      );

    default:
      return null;
  }
};

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

const getWidget = (menuType, quickSearchMode) => {
  if (menuType !== PROMPT_MENU_TYPE.all) {
    return 'add_to_prompt';
  } else {
    if (quickSearchMode) {
      return 'resource_search_quick';
    }
    return 'resource_search';
  }
};
